import type { GeneralSettings } from '../types';

export const mockSystemConfiguration: GeneralSettings = {
  id: 'config_001',
  siteName: 'Fit UI Manager',
  siteDescription: 'Comprehensive fitness management platform for coaches and clients',
  contactEmail: 'support@fitui.com',
  supportUrl: 'https://support.fitui.com',
  timezone: 'America/New_York',
  language: 'en',
  dateFormat: 'MM/DD/YYYY',
  timeFormat: '12',
  currency: 'USD',
  maintenanceMode: false,
  registrationEnabled: true,
  emailVerificationRequired: true,
  termsOfServiceUrl: 'https://fitui.com/terms',
  privacyPolicyUrl: 'https://fitui.com/privacy',
  businessHours: {
    monday: { isOpen: true, start: '09:00', end: '18:00' },
    tuesday: { isOpen: true, start: '09:00', end: '18:00' },
    wednesday: { isOpen: true, start: '09:00', end: '18:00' },
    thursday: { isOpen: true, start: '09:00', end: '18:00' },
    friday: { isOpen: true, start: '09:00', end: '18:00' },
    saturday: { isOpen: true, start: '10:00', end: '16:00' },
    sunday: { isOpen: false, start: '10:00', end: '16:00' },
  },
  updatedBy: 'admin@fitui.com',
  updatedAt: '2024-01-25T10:30:00Z',
}; 